import React from "react";
import DialogComponent from "@Components/Common/DialogComponent";
import ProfessionalRetailerStyle from "@PagesComponent/Professional_RetailerPopup/Professional_Retailer.style";
import { RegionDropdown } from "react-country-region-selector";
import { NewYorkPopUp } from "@Components/Common/CommonMethods";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import ContactUsPopupStyle from "./ContactUsPopup.style";
import api from "@api/Apis";
import CircularProgress from '@material-ui/core/CircularProgress';


const ContactUsPopup = ({ openContactForm, setOpenContactForm, setInnerLoader, setShowLoader }) => {

    const schema = yup.object().shape({
        first_name: yup.string().trim()
            .required('Name is required'),
        email: yup.string().trim()
            .required('Email is required')
            .email('invalid email'),

    })


    const { register, handleSubmit, errors, getValues, setError, setValue, reset } = useForm({ mode: 'onChange', resolver: yupResolver(schema) });
    const [selectState, setSelectState] = useState({ value: "", error: "" })
    const [newYorkCheck, setNewyorkCheck] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const [wellnessInfo, setWellnessInfo] = useState("No");

    const [displayLoader, setDisplayLoader] = useState(false);

    const [successMsg, setSuccessMsg] = useState('');


    async function onSubmit(data) {
        console.log("inside_the_submit_form");
        data.state = selectState?.value;
        data.wellness_info = wellnessInfo;
        setDisplayLoader(true)

        await api.contactUsFormAPI(data).then((response) => {
            console.log('response', response);
            if (response?.status === 200) {
                console.log("response?.data?.message", response);
                setSuccessMsg(response?.data?.message);
                reset();
                // setCheckedValue();
                // setShowForm(false);
                setShowSuccessMessage(true);
                setDisplayLoader(false);

                setTimeout(function () { setOpenContactForm(false) }, 3000);

            }
        }).catch((error) => {
            console.error('API call failed:', error);
        });
    }

    function _InputField(fieldName, placeHolder, label = null) {
        return (
            <div className="mb-3 field-class">
                {label && <label htmlFor={fieldName}>{label}</label>}
                <input type="text" className="form-control" name={fieldName} placeholder={placeHolder} ref={register} />
                {errors[fieldName] && <span className="error">{errors[fieldName]?.message}</span>}
            </div>
        )
    };

    return (
        <>
            <ContactUsPopupStyle>
                {/* <div class="left-img"><img src="/images/molecularleft1.png" /></div>
            <div class="right-img"><img src="/images/molecular_right.png" /></div> */}
                <div className="container">
                    <div className={'professional-form ' + (showSuccessMessage ? 'showSuccessMessage' : '')}>
                        <form className="signupform main-sign-frm" style={{ background: '#5FB5BE' }} onSubmit={handleSubmit(onSubmit)}>
                            <p>Thank you for your interest in</p>
                            <p>SNiP Nutrigenomics</p>
                            {_InputField('first_name', "First Name*")}
                            {_InputField('last_name', "Last Name")}
                            {_InputField('email', "E-mail*")}
                            {_InputField('phone_no', "Phone Number")}
                            {_InputField('city', "City")}
                            <div className="mb-3 field-class">
                                <RegionDropdown
                                    country={'US'}
                                    value={selectState?.value}
                                    name="state"
                                    className="form-control"
                                    valueType="short"
                                    defaultOptionLabel="State"
                                    countryValueType="short"
                                    onChange={(val) => {
                                        if (val === "NY") { setNewyorkCheck(true) } else { setNewyorkCheck(false) };
                                        setSelectState({ value: val, error: "" });
                                    }}
                                />
                                {(selectState?.value === "") && <span className="error">{selectState?.error}</span>}
                                <NewYorkPopUp open={newYorkCheck} setClose={setNewyorkCheck} />
                            </div>
                            <div className="mb-3 field-class">
                                <p style={{ color: 'white' }}>Are you a wellness professional?
                                    &nbsp;<input type="radio" name="wellness_info" value="Yes" onChange={() => setWellnessInfo("Yes")} />Yes
                                    &nbsp;<input type="radio" name="wellness_info" value="No" onChange={() => setWellnessInfo("No")} defaultChecked />No
                                </p>
                            </div>
                            <div className="mb-3 field-class">
                                <label htmlFor="comments">Comments</label>
                                <textarea rows={8} cols={10} className="form-control" name="comment" ref={register} />
                                {/* {errors.comment && <span className="error">{errors.comment.message}</span>} */}
                            </div>
                            <div className="mb-0 mt-3 field-class">
                                {/* {displayLoader?
                                <div className='loader_values'>
                                <CircularProgress />
                            </div>
                            : */}
                                <button type="submit" className=" btn-primary">{displayLoader ? <CircularProgress /> : "Submit"}</button>
                                {/* } */}

                            </div>
                        </form>
                        {/* )} */}
                        {showSuccessMessage && <div className='success'><p>{successMsg}</p></div>}
                    </div>
                </div>
            </ContactUsPopupStyle>

            {/* )} */}

        </>
    )
}

export default ContactUsPopup;